<template>
  <div id="container" v-if="fetch_data">
    <section id="atusatus-entry">
      <div class="wrap">
        <div class="cts_box">
          <h1 class="main_ttl"><span>{{ fetch_data.title }}</span></h1>

          <div v-html="fetch_data.description"></div>

        </div>

        <div class="body_tbl" v-if="!fetch_data.contest_period">
          <h3 class="atsuatsu_entry_txt"><span>こちらのコンテストは既に締め切りました。</span></h3>

        </div>

        <div class="body_tbl" v-else-if="fetch_data.entry">
          <h3 class="atsuatsu_entry_txt"><span>こちらのコンテストには既にエントリー中です。</span></h3>
        </div>

        <div class="body_tbl" v-else>
          <h3 class="min_ttl"><span>必要事項をご入力の上、送信ボタンを押してください。</span></h3>
          <p class="lead_txt"> <!--メールでのお問い合わせを希望される塾生の方は、以下のフォームにご入力の上「送信する」ボタンを押してください。<br>-->
            <span class="blue bold">*のついている箇所は必ず入力して下さい。</span>
          </p>
          <form action="">
            <div class="msg_box error" v-if="errors">
              <h3>ご入力内容にエラー項目があります</h3>
              <p>エラー個所は赤く表示され、エラー理由がすぐ下に赤字で示されます。<br>お手数ですが、エラー項目を修正してからボタンを押してください。
              </p>
            </div>

            <div class="input_set ticker">
              <div class="label">銘柄コード<span>*</span>（半角英数）</div>
              <input type="text" placeholder="例：8604"
                     v-bind:class="{error: validation_errors.ticker}" v-model="ticker" @input="tickerChange" maxlength="4">
              <ValidationErrors :errors="validation_errors.ticker"
                                v-if="validation_errors.ticker"></ValidationErrors>
            </div>
            <div class="input_set">
              <div class="label">銘柄名（銘柄コードから検索されます）</div>
              <input type="text" disabled style="background: #eee"
                     v-bind:class="{error: validation_errors.name}" v-model="name">
            </div>
            <div class="input_set comment">
              <div class="label">コメント<span>*</span>（32文字以上/1024文字以下）※現在: {{ comment.length }}文字</div>
              <textarea name="" placeholder="銘柄の選定についてコメントをお願いします"
                        v-bind:class="{error: validation_errors.comment}"
                        v-model="comment"></textarea>
              <ValidationErrors :errors="validation_errors.comment"
                                v-if="validation_errors.comment"></ValidationErrors>
            </div>
            <div class="button_wrap">
              <p>必要な項目にすべて記入できたら<br class="sp">こちらのボタンを押してください。</p>
              <input type="button" class="submit light arrow" value="確認する" v-on:click="sendClicked()"
                     v-bind:disabled="disabled">
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Libraries from '@/components/Libraries.vue'
import ValidationErrors from '@/components/ValidationErrors.vue'

export default {
  mixins: [Libraries],
  components: {
    ValidationErrors
  },
  data() {
    return {
      fetch_data: null,
      ticker: this.$store.state.entry ? this.$store.state.entry.ticker : null,
      name: this.$store.state.entry ? this.$store.state.entry.name : null,
      comment: this.$store.state.entry ? this.$store.state.entry.comment : '',
      stock: null,

      errors: false,
      validation_errors: {},
      disabled: false
    }
  },
  mounted() {
    if (!this.isJoinRank()) {
      this.$router.push({name: 'UsersCustomerTop'})
    } else {
      this.fetchData()
    }
  },
  methods: {
    isJoinRank() {
      return this.$route.meta.current_user &&
          this.$route.meta.current_user.rank !== 'rank_free' &&
          this.$route.meta.current_user.rank !== 'rank_student_month'
    },
    fetchData() {
      this.startAjax()
      this.axios
          .get(`${this.env.api_base_url}stock_contest/last_contest.json`)
          .then(response => {
            this.fetch_data = response.data
            if (!this.fetch_data.contest_period) {
              this.finishAjax()
              this.$router.push({ name: 'AtsuatsuLp' })
            }
          })
          .catch((response) => {
            this.errorAjax(response)
          })
          .finally(() => {
            this.finishAjax()
          })
    },

    tickerChange() {
      this.ticker = this.replaceFullToHalf(this.ticker).toUpperCase()
      this.name = null
      if (this.ticker.length !== 4) {
        return
      }

      // this.startAjax()
      this.axios
          .get(`${this.env.api_base_url}stock_contest/stock_search.json`, {
            params: {
              ticker: this.ticker,
            }
          }).then(response => {
        this.stock = response.data
        this.name = this.stock.name
      })
          .catch(() => {
            // this.errorAjax(response)
          })
          .finally(() => {
            // this.finishAjax()
          })

    },

    sendClicked() {
      if (this.disabled) return

      this.errors = false
      this.validation_errors = {}
      if (!this.ticker) {
        this.validation_errors.ticker = ['銘柄コードを入力してください']
      } else if (!this.name) {
        this.validation_errors.ticker = ['正しい銘柄コードを入力してください']
      }
      if (!this.comment) {
        this.validation_errors.comment = ['コメントを入力してください']
      } else if (this.comment.length < 32 || this.comment.length > 1024) {
        this.validation_errors.comment = ['コメントは、32文字以上/1024文字以下の範囲で入力してください']
      }
      if (Object.keys(this.validation_errors).length > 0) {
        this.errors = true
        return
      }

      this.$store.state.entry = {
        ticker: this.ticker,
        name: this.name,
        comment: this.comment
      }

      this.$router.push({name: 'AtsuatsuEntryConfirm'})
    }
  }
}
</script>
